import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';
import { ISemanticRuleResponse } from './semantic-rule.model';

@Injectable({
	providedIn: 'root',
})
export class SemanticRuleRequester extends DcBaseRequester<ISemanticRuleResponse> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('SEMANTIC_CONTEXT');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getSemanticRuleList(
		useCache: boolean
	): Observable<ReadonlyArray<ISemanticRuleResponse>> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		const cachePolicy = useCache
			? CachePolicyEntity.build({
					policy: CachePolicy.NetworkAndCache,
					evictTimeoutInSeconds: 60,
					isCacheable: true,
			  })
			: CachePolicyEntity.build({
					policy: CachePolicy.NetworkOnly,
					evictTimeoutInSeconds: 0,
					isCacheable: false,
			  });
		return this.get<Array<ISemanticRuleResponse>>(url, cachePolicy);
	}

	public delete(semanticId: number): Observable<void> {
		const url = this.urlService.generateUrl(
			this.resource,
			{},
			{
				semanticId,
			}
		);
		return this.http.delete<void>(url);
	}
}
